module.exports = __webpack_public_path__ + "img/06.d1e0ec39.png";